import Modal, { Size } from '@/components/Modal'
import cn from '@/utilities/cn'

import ButtonModal from './ButtonModal'
import ModalVariantLogo from './ModalVariantLogo'

export type Actions = 'creating' | 'editing' | 'deleting' | 'deactivating' | 'importing' | 'processing' | null

type Props = {
  size?: Size
  variant: 'success' | 'warning' | 'error' | 'info'
  isOpen: boolean
  onConfirm: () => void
  onSecondaryConfirm?: () => void
  onCancel: () => void
  message: any
  subMessage: any
  confirmText?: string
  secondaryText?: string
  cancelText?: string
  loadingText?: string
  loading?: boolean
  disabled?: boolean
  showCancel?: boolean
}

const ConfirmDialog = ({
  size = 'xs',
  variant,
  isOpen,
  onConfirm,
  onSecondaryConfirm,
  onCancel,
  message,
  subMessage,
  confirmText = 'Confirm',
  secondaryText,
  cancelText = 'Cancel',
  loadingText = 'Loading...',
  loading = false,
  disabled = false,
  showCancel = true
}: Props) => {
  return (
    <Modal size={size} isOpen={isOpen} onClose={() => onCancel()}>
      <div className="px-4 py-3">
        <div className="sm:flex sm:items-start">
          <ModalVariantLogo variant={variant} />
          <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
            <h3 className="text-base font-semibold leading-6 text-zinc-900">{message}</h3>
            <div className="mt-2">
              <p className="text-sm text-zinc-500">{subMessage}</p>
            </div>
          </div>
        </div>

        <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
          <ButtonModal
            disabled={disabled || loading}
            variant={variant}
            onConfirm={onConfirm}
            loadingText={loadingText}
            confirmText={confirmText}
          />
          {secondaryText && onSecondaryConfirm && (
            <ButtonModal
              disabled={disabled || loading}
              variant={variant}
              onConfirm={onSecondaryConfirm}
              loadingText={loadingText}
              confirmText={secondaryText}
            />
          )}
          {showCancel && (
            <button
              type="button"
              disabled={loading}
              className={cn(
                'mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-zinc-900 shadow-sm ring-1 ring-inset ring-zinc-300 hover:bg-zinc-50 sm:mt-0 sm:w-auto'
              )}
              onClick={() => onCancel()}
            >
              {cancelText}
            </button>
          )}
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmDialog
